import React, { useState, Fragment } from "react";
import "../../Checkout.css";
import ProductDetail from "../Http/ProductDetail";
import { properties } from '../../properties';

const OrderReviewSuccess = ({ successResponse, checkoutParam }) => {
    const [seeMoreDetail, setSeeMoreDetail] = useState(false);
    let digest = "", fieldName = "", responseBody = [], security_check = "";
    const operation = successResponse.operation, md5 = require('md5'),
        isSaveCard = (checkoutParam.intentType === properties.INTENTTYPE.SAVE_CARD) ? true : false;

    for (const property in properties.md5_digest[operation]) {
        if (successResponse[properties.md5_digest[operation][property]]) {
            digest += successResponse[properties.md5_digest[operation][property]];
        }
    }
    for (const outfield in properties.output_params[operation]) {
        fieldName = properties.output_params[operation][outfield];
        if (fieldName === properties.RESPONSE_APP_ID_FIELDNAME) {
            fieldName = properties.NEW_RESPONSE_APP_ID_FIELDNAME;
        }
        responseBody.push(
            <div className="orderReviewSuccess-row" key={outfield}>
                <div className="orderReviewSuccess-col">
                    <label>{fieldName}</label>
                </div>
                <div className="orderReviewSuccess-col">
                    {successResponse[properties.output_params[operation][outfield]]}
                </div>
            </div>
        );
    }
    if (md5(digest + properties.PASSWORD) === successResponse["security"]) {
        security_check = properties.SECURITY_CHECK_PASS;
    }
    else {
        security_check = properties.SECURITY_CHECK_FAIL;
    }
    responseBody.push(
        <Fragment key="securityKey">
            <div className="orderReviewSuccess-row">
                <div className="orderReviewSuccess-col">
                    <label>security</label>
                </div>
                <div className="orderReviewSuccess-col">
                    {successResponse["security"]}
                    <span className={`operationName ${(security_check === properties.SECURITY_CHECK_FAIL) ? "red" : ""}`}>{security_check}</span>
                </div>
            </div>
        </Fragment>
    );

    const handleReadMore = () => {
        setSeeMoreDetail(seeMore => seeMore = !seeMore);
    }

    return (
        <div>
            <div className="orderReviewSuccess">
                {successResponse.returnCode !== '0' ? (
                    <div className="orderReviewStatusRow failed">
                        {isSaveCard ? (<h1>Oops! card details failed to save.</h1>) :
                            (successResponse.operation === 'auth' ? (<h1>Oops! Authroisation failed.</h1>)
                                : ((successResponse.operation === 'authsettle') ? <h1>Oops! Payment failed.</h1>
                                    : <h1>Oops! Subscription failed.</h1>)
                            )}
                        <div className="orderReviewStatus red">
                            <span>FAILED</span>
                        </div>
                    </div>
                ) : null}
                {successResponse.returnCode === '0' ? (
                    <div>
                        <div className="orderReviewStatusRow">
                            {isSaveCard ? (<h1>Your card details saved.</h1>) : (<h1>Thank you for your order!</h1>)}
                            <div className="orderReviewStatus green">
                                <span>SUCCESS</span>
                            </div>
                        </div>
                        <p>Your order number is <b>A1043454364</b></p>
                    </div>
                ) : null}
                <div className="orderReviewSuccess-row">
                    <div className="orderReviewSuccess-col">
                        <label>Bill to</label>
                    </div>
                    <div className="orderReviewSuccess-col">
                        {checkoutParam.addressLine1}, {checkoutParam.addressLine2}, {checkoutParam.city}, {checkoutParam.state} {checkoutParam.zip}
                    </div>
                </div>
                {successResponse.returnCode === '0' ? (
                    <div className="orderReviewSuccess-row">
                        <div className="orderReviewSuccess-col">
                            <label>Payment</label>
                        </div>
                        <div className="orderReviewSuccess-col">
                            <div>
                                {successResponse.acquirerName} {successResponse.maskedCardNumber}
                                <span className="operationName">{properties.OPERATION_NAME_MAPPING[successResponse.operation] || ''}</span>
                            </div>
                        </div>
                    </div>) : null}
                {!seeMoreDetail && (
                    <div className="orderReviewSuccess-row">
                        <div className="orderReviewSuccess-col seeMoreLink">
                            <button onClick={handleReadMore}>See More</button>
                        </div>
                    </div>
                )}
                {seeMoreDetail ? (responseBody) : null}
                {seeMoreDetail && (
                    <div className="orderReviewSuccess-row">
                        <div className="orderReviewSuccess-col seeMoreLink">
                            <button onClick={handleReadMore}>See Less</button>
                        </div>
                    </div>
                )}
                {((checkoutParam.INTENTTYPE !== properties.INTENTTYPE.SAVE_CARD)
                    && (successResponse.operation !== "tokenise")
                    && (successResponse.operation !== "validate"))
                    && (
                        <div className="orderReviewSuccess-row">
                            <div className="orderReviewSuccess-col">
                                <ProductDetail response={successResponse} checkoutParam={checkoutParam} ></ProductDetail>
                            </div>
                        </div>
                    )}
            </div>
        </div>
    );
}

export default OrderReviewSuccess;